import { useQuery } from "@tanstack/react-query";
import { getSettings } from "@/api/settings";
import { DEFAULT_COST_UNIT } from "@/lib/units";

/**
 * Returns the tenant's configured currency code (e.g. "EUR", "BYN", "USD").
 * Falls back to "EUR" while the settings are loading or unavailable.
 */
export function useCostUnit(): string {
  const { data } = useQuery({
    queryKey: ["settings"],
    queryFn: getSettings,
    staleTime: 5 * 60 * 1000,
  });
  return data?.cost_unit || DEFAULT_COST_UNIT;
}
